// REACT
import React from "react";

// MATERIAL-UI
import { Grid, Typography } from "@mui/material";

// ASSETS
import { InstructionsStyles } from "../common/styles/Instructions.styles";
import { IntructionProps } from "../common/types/intructionsTypes";
import { NavLink } from "react-router-dom";
import { trackEvent } from "src/Amplitude";

const Instructions = ({ options }: IntructionProps): JSX.Element => {
  const classes = InstructionsStyles();
  const title = "Indicative prices only";
  const description = "For FIAT deposits, please see our ";
  const link = "banking details";
  return (
    <Grid container className={classes.container}>
      {options === "secondary" && (
        <Grid item xs={12} textAlign={"center"}>
          <Typography className={classes.title}>{title}</Typography>
        </Grid>
      )}
      {options === "primary" && (
        <Typography className={classes.description}>
          {description}
          <NavLink
            onClick={() => trackEvent("Select_Wallets_Page_Banking_Details")}
            to="/banking/details"
            className={classes.link}>
            {link}
          </NavLink>
        </Typography>
      )}
    </Grid>
  );
};

export default Instructions;
